import React from 'react'

const BluePrism = (
  <div className='md:w-4/5 mx-auto py-10 text-lg'>
    <h1 className='text-2xl font-bold'>
      Blue Prism
    </h1>
    <br />
    <div className='md:px-5 text-gray-500'>
      Blue Prism is an RPA Tool which holds the capability of virtual workforce powered
      by software robots. This helps the enterprises to automate the business operations
      in an agile and cost-effective manner. The tool is based on Java Programming
      Language and offers a visual designer with drag and drop functionalities.
      <h1 className='text-lg font-bold md:pr-5 mt-6 text-gray-900'>
        Features of Blue Prism
      </h1>
      <br />
      <div className='md:px-5'>
        <ul className='md:px-5 list-disc pl-5 text-gray-500'>
          <li>
            <span className='font-bold mr-2 text-gray-900'>Secure &amp; Accurate:</span>
            There is no limit to the number of processes which
            need to be executed in this tool. Blue Prism delivers secure and accurate
            results to any number of processes that you wish to automate.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'>Robust:</span>
            It provides robust features like load balancing, data encryption,
            and end-to-end auditing. So, every change is audited and related back to the
            user related to it.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Scalable &amp; Resilient: </span>
            It allows scalability with central management. So, all
            the processes can be automated as per the need and can be monitored
            centrally.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> 24*7 Workforce: </span>
            The tool is designed to work intelligently without a
            person physically monitoring every action occurring on the screen.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Analytics: </span>
            Provides extended features to configure Dashboards so that the
            session information can be redirected to the Monitoring Systems.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Data Security and Data Abstraction: </span>
            As the tool is designed to work
            autonomously, all the processing is performed and is stored in a data
            center. This provides a well-defined data abstraction of data and process
            security.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Provide Cloud support: </span>
            Provides working capacity support as per the
            business requirement. So, users must just create workers on demand and
            manage them centrally.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Execution Intelligence: </span>
            Robots connect to systems and react dynamically
            to the responses in the data on multiple environments.
          </li>
        </ul>
      </div>
      <h1 className='text-lg font-bold md:pr-5 mt-6 text-gray-900'>
        Benefits of Blue Prism
      </h1>
      <br />
      <div className='md:px-5'>
        <ul className='md:px-5 list-disc pl-5 text-gray-500'>
          <li>
            <span className='font-bold mr-2 text-gray-900'>Better Service Quality:</span>
            As end-to-end auditing is performed by the Digital
            workforce; this tool offers a better service quality.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'>High Accuracy:</span>
            This tool performs tasks in such a way that outcomes are
            produced with high accuracy and low errors.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Scalable: </span>
            Provides a scalable approach, as this tool is not based on scripts or
            recorders but is based on intelligent Digital Workforce performing tasks.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Quick Deployment of Services: </span>
            The services can be easily deployed as it can
            automate the application’s controls, irrespective of their onscreen position.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Flexible Workforce: </span>
            The Digital Workforce is designed in such a way that it
            doesn’t need rest. It can work 24*7 without taking a break and give the
            same results with high accuracy.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Statistics:</span>
            This tool offers dashboards so that you can analyze the data, the
            process’s session and much more.
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default BluePrism